/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'truncateSeriesNumber',
  standalone: true,
})
export class TruncateSeriesNumberPipe implements PipeTransform {

  transform(originalOrderNumber: string): string | null {
    if (originalOrderNumber) {
      const numericPartStartIndex: number = originalOrderNumber.indexOf('_') + 1;
      const numericOrderNumberPart: string = originalOrderNumber.substring(numericPartStartIndex, originalOrderNumber.length);
      return parseInt(numericOrderNumberPart).toString();
    }
    return null;
  }
}
